/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/fancyradio/fancyradio_styles';
import RadioField from 'material/form/field/radio/radio';



/* ========== ~~~~~~~~~~ FORM : FIELD : RADIO : FANCYRADIO : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const FancyRadioField = (props) => (
    <label className={`fancyradio ${props.classes.fancyradio}`}>
        <RadioField isList = {props.isList} name = {props.name} checked = {props.checked} handleChange = {props.handleChange} disabled = {props.disabled}/>
        <span className = {`fancyradiospan`}/> {props.title}
    </label>
);


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(FancyRadioField);